// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--CBVv6";
export var Container_BottomWaved = "styles-module--Container_BottomWaved--Y+Oro";
export var Container_UpperBottomWaved = "styles-module--Container_UpperBottomWaved--zwYZV";
export var Container_UpperWaved = "styles-module--Container_UpperWaved--8hLsm";
export var Footer = "styles-module--Footer--eLBgx";
export var Header = "styles-module--Header--gAMKJ";